"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { Mascot } from "@/components/landing/Mascot";

const NAV_LINKS = [
  { label: "Features", href: "#solution" },
  { label: "How It Works", href: "#steps" },
  { label: "Use Cases", href: "#use-cases" },
  { label: "Compare", href: "#compare" },
  { label: "FAQ", href: "#faq" },
];

export function StickyNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[var(--cream)] border-b-[3px] border-[var(--ink)] sticker-shadow"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 pop-hover">
          <Mascot spriteKey="surggie_1" scale={2} />
          <span
            className="font-extrabold text-lg tracking-tight gold-shimmer"
            style={{ fontFamily: "var(--font-manrope)" }}
          >
            SURGGIES
          </span>
        </Link>

        {/* Center links - hidden on mobile */}
        <ul className="hidden md:flex items-center gap-2">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="pop-hover inline-block text-[var(--ink-soft)] hover:text-[var(--ink)] text-sm font-mono px-3 py-1.5 rounded-full hover:bg-[var(--cream-deep)] transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right CTAs */}
        <div className="flex items-center gap-3">
          <Link
            href="/login"
            className="hidden sm:block text-[var(--ink-soft)] hover:text-[var(--ink)] text-sm font-mono transition-colors"
          >
            Sign In
          </Link>
          <Link
            href="/register"
            className="btn-gold sticker-press text-sm px-4 py-2 font-mono uppercase tracking-wider"
            style={{ fontFamily: "var(--font-manrope)" }}
          >
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
}
